var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"notranslate",attrs:{"translate":"no"}},[(_vm.estaAutenticado)?_c('view-sidebar'):_vm._e(),_c('v-main',{staticClass:"white notranslate",attrs:{"translate":"no"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }